import React from "react";
import { motion, useScroll, useSpring, useReducedMotion } from "framer-motion";

/*
 * ScrollProgress
 * --------------
 * A whisper-quiet champagne hairline pinned at the very top of the viewport
 * that scales horizontally from 0 → 1 as the reader scrolls. Gives a felt
 * sense of progress without ever showing a number, percentage, or chapter
 * marker.
 *
 * Fixed to viewport top, 1.5px, gradient with soft champagne core so it
 * looks like light passing along a wire. Respects prefers-reduced-motion
 * by falling back to a static faint line.
 */
export default function ScrollProgress() {
  const reduced = useReducedMotion();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 90,
    damping: 26,
    mass: 0.4,
  });

  if (reduced) {
    return (
      <div
        aria-hidden
        data-testid="scroll-progress"
        className="fixed top-0 left-0 right-0 h-[1.5px] z-50 pointer-events-none"
        style={{
          background:
            "linear-gradient(90deg, transparent, rgba(201,169,97,0.35), transparent)",
        }}
      />
    );
  }

  return (
    <motion.div
      aria-hidden
      data-testid="scroll-progress"
      className="fixed top-0 left-0 right-0 h-[1.5px] z-50 origin-left pointer-events-none"
      style={{
        scaleX,
        background:
          "linear-gradient(90deg, rgba(201,169,97,0.15), rgba(245,216,150,0.9) 45%, rgba(201,169,97,0.6) 70%, transparent)",
        boxShadow: "0 0 12px rgba(201,169,97,0.5)",
      }}
    />
  );
}
